import axiosClient from "./axiosClient";

const getAllCountries = async (params) => {
  return await axiosClient.get("/countries/all", { params });
};

export { getAllCountries };
